import $axios from '../services/apiLms.js'
import cookie from 'vue-cookie'

const actions = {
    submit({ commit }, payload) {
        // localStorage.setItem('token_operator_tatib', null)
        // commit('SET_TOKEN', null, { root: true })
        return new Promise((resolve, reject) => {
           $axios.post('/operator/auth/login', payload)
                .then(response => {
                    if (response.data.status) {
                        // localStorage.setItem('token', response.data.data.access_token)
                        cookie.set('token_operator_tatib', response.data.data.access_token, { expires: 1 })
                        commit('SET_TOKEN', response.data.data.access_token, { root: true })
                        // let userData = (({ name, username }) => ({ name, username }))(response.data.data)
                        // // localStorage.setItem('user', JSON.stringify(userData))
                        // cookie.set('user', JSON.stringify(userData), { expires: 1 })
                        // commit('SET_USERNAME', response.data.data.teacher.name, { root: true })
                    } else {
                        commit('SET_ERRORS', { invalid: 'Email/Password Salah' }, { root: true })
                    }
                    resolve(response.data)
                })
                .catch(error => {
                    commit('SET_ERRORS', error.response.data, { root: true })
                    reject(error.response.data)
                })
        })
    },
    logoutSubmit({ commit }) {
        return new Promise(resolve => {
           $axios.post('/api/logout')
                .then(response => {
                    if(response.data.status) {
                        // localStorage.removeItem('token_operator_tatib')
                        // localStorage.removeItem('user')
                        cookie.delete('token_operator_tatib')
                        cookie.delete('user')
                        commit('SET_TOKEN', null, { root: true })
                    } else {
                        commit('SET_ERRORS', { invalid: 'Server error' }, { root: true })
                    }
                    resolve(response)
                })
        })
    },
    // loginDummy({ commit }) {
    //     let token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9'
    //     cookie.set('token', token)
    //     commit('SET_TOKEN', token, { root: true })
    // },
    // logoutDummy({ commit }) {
    //     cookie.delete('token')
    //     commit('SET_TOKEN', null, { root: true })
    // }
}

export default {
    namespaced: true,
    actions,
}